module.exports = __webpack_public_path__ + "media/images/phone-69271210.svg";